function Spinner() {
    return (
      <div className="flex flex-row space-x-4 spinner" >
      <div className="w-12 h-12 rounded-full animate-spin
  border border-solid border-yellow-500 border-t-transparent"></div>

     
  </div>

    );
  }
  
  export default Spinner;